import { firebase, perf, trace } from '../libraries/Firebase';
import { isWeb } from './BooleanUtility';

export const getFirebasePerformanceTrace = (traceName) => isWeb() ? trace(perf, traceName) : firebase.perf().newTrace(traceName);
